import { ShowMore } from "@/molecules/ShowMore"

import type { DetectionDetails } from "@/api/useInventory.types"
import type { TFunction } from "@/hooks/useTranslation"

export const DetectionDetailsCell = (t: TFunction) =>
  function DetectionDetailsCellComponent(
    value: DetectionDetails<string>,
    record: { key: string }
  ) {
    const { discoveredAt, lastScan, lastSeen } = value

    return (
      <ShowMore
        id={`detection-details-cell-${record.key}`}
        label={<ShowMore.Label.Component>{lastScan}</ShowMore.Label.Component>}
      >
        <ShowMore.Component title="Detection Details">
          <ShowMore.Description
            items={[
              {
                label: t("general.firstDetected"),
                value: discoveredAt
              },
              {
                label: t("general.lastDetected"),
                value: lastSeen
              },
              {
                label: t("general.lastScan"),
                value: lastScan
              }
            ]}
          />
        </ShowMore.Component>
      </ShowMore>
    )
  }
